export const commonKey = {
    ROLE_KEY: 'role_id',
	TOKEN_KEY: 'token',
	USER_KEY: 'user',
	REGISTER_PHONE: 'register_phone',
	LOGIN_PHONE: 'login_phone',
	// 网站设置
	WEB_INFO: 'webInfo',
	// 功能设置
	FUN_SETTINGS: 'fun_setting'
}